import { useState } from 'react';

import { BOUNDARY_LAYERS, FLIGHT_PATH_LAYERS } from './constants';
import type { Map } from './types';

const setLayerGroupVisibility = (map: Map, layers: string[], isVisible: boolean) => {
    const visibility = isVisible ? 'visible' : 'none';

    for (const layer of layers) {
        if (map.getLayer(layer)) {
            map.setLayoutProperty(layer, 'visibility', visibility);
        }
    }
};

const useLayerVisibility = () => {
    const [isFlightPathsVisible, setIsFlightPathsVisible] = useState(true);
    const [isBoundaryVisible, setIsBoundaryVisible] = useState(true);

    const toggleFlightPaths = (map?: Map): boolean => {
        if (!map) {
            return isFlightPathsVisible;
        }

        const newVisible = !isFlightPathsVisible;

        setIsFlightPathsVisible(newVisible);
        setLayerGroupVisibility(map, FLIGHT_PATH_LAYERS, newVisible);

        return newVisible;
    };

    const toggleBoundary = (map?: Map): boolean => {
        if (!map) {
            return isBoundaryVisible;
        }

        const newVisible = !isBoundaryVisible;

        setIsBoundaryVisible(newVisible);
        setLayerGroupVisibility(map, BOUNDARY_LAYERS, newVisible);

        return newVisible;
    };

    return {
        isBoundaryVisible,
        isFlightPathsVisible,
        toggleBoundary,
        toggleFlightPaths
    };
};

export default useLayerVisibility;
